module.exports = __webpack_public_path__ + "static/nikkah-b27f5d79363679e11c63d869baafb211.png";